/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import {
    arrayOf,
    bool,
    func,
    number,
    object, shape, string,
} from 'prop-types';
import {
    Button, Grid, withStyles,
} from '@material-ui/core';
import { connect, useDispatch } from 'react-redux';
import Media from 'react-media';
import { compose } from 'recompose';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import RecipientBoxCollapse from './RecipientBoxCollapse';
import configENV from '../../../config';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import OccasionDropdown from './OccasionDropdown';
import DesktopPagination from '../DesktopGiftList/DesktopPagination';
import GraphqlPortalLoader from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import MiniCart from '../../../../../components/Checkout/containers/CheckoutFood/components/Partials/MiniCart/MiniCart';
import AccountHome from '../../MyAccount/AccountHome';
import withPageView from '../../../../../helpers/tracking/hocs/withPageView';
import { trackPage } from '../../../../../helpers/tracking/common/commonTrackingHelpers';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    rightContainer: {
        padding: '24px 60px',
        '@media only screen and (max-width: 1439.5px)': {
            padding: '24px 47px',
        },
        '@media only screen and (max-width: 1023.5px) ': {
            padding: '0px',
        },
    },
    giftListWrapper: {
        display: 'flex',
        flexDirection: 'column',
        '@media only screen and (max-width: 600px) ': {
            display: 'block',
        },
    },
    giftListContainer: {
        display: 'flex',
        alignItems: 'center',
        '@media only screen and (max-width: 600px) ': {
            '& >div': {
                width: '100%',
            },
        },
        '& .occasionDropdown': {
            backgroundColor: 'rgba(232, 241, 237, 1)',
            border: `1px solid ${theme.palette.cms?.black || '#2f2f2f'}`,
            padding: '0px 15px',
            '&:before': {
                content: 'inherit',
            },
            '&:after': {
                content: 'inherit',
            },
            '& .MuiSelect-select': {
                fontSize: '1rem',
                '&:focus': {
                    backgroundColor: 'rgba(232, 241, 237, 1)',
                },
            },
        },
    },
    giftListTitle: {
        paddingRight: '19px',
        lineHeight: '1.25rem',
        fontSize: '1rem',
        fontWeight: 700,
    },
    recipientButton: {
        borderRadius: '3px',
        width: '339px',
        height: '56px',
        padding: '15px 28px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        flexShrink: '0',
        fontSize: '18px',
        backgroundColor: 'inherit',
        color: theme.palette.cms?.black || '#2f2f2f ',
        lineHeight: '1.25rem',
        border: `1px solid ${theme.palette.cms?.black || '#2f2f2f '}`,
        fontWeight: 700,
        boxShadow: 'inherit',
        margin: '20px 0px 8px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: 'inherit',
            boxShadow: 'none',
        },
        '@media only screen and (max-width: 600px) ': {
            padding: '11px 24px',
            width: '100%',
            height: '46px',
            fontSize: '16px',
            lineHeight: '24px', /* 150% */

        },
    },
    paginationWrapper: {
        justifyContent: 'center',
        marginTop: '32px',
        '& .navButton': {
            boxShadow: 'inherit',
        },
        '& .currentPage': {
            color: theme.palette.cms?.black || '#2f2f2f !important',
            backgroundColor: 'rgba(232, 241, 237, 1)',
            borderRadius: '50%',
            padding: '0px 6px !important',
        },
    },
    account: {
        margin: '0px',
        fontSize: '0.875rem',
        lineHeight: '1.125rem',
        paddingBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        '& button': {
            minWidth: '20px',
            padding: '0px',
            '& svg': {
                width: '0.6em',
                height: '0.6em',
            },
        },

    },
    title: {
        marginBottom: '34px',
        '@media only screen and (max-width: 1023.5px) ': {
            marginBottom: '16px',
        },
    },
    titleText: {
        fontSize: '2rem',
        lineHeight: '2.5rem',
        fontWeight: 700,
        '@media only screen and (max-width: 1023.5px) ': {
            fontSize: '24px',
            lineHeight: '32px',
        },
    },
    container: {
        '@media only screen and (max-width: 1023.5px) ': {
            padding: '24px 0px',
        },
    },
    giftListV2Container: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
});
const { PERSIST_KEY } = configENV;
const GiftListUserV2 = ({
    classes, featureFlags, recipientsByPage,
    occasionId,
    occasions,
    orderId,
    handleNavigateToPage,
    handleGiftListAddNewRecipientClicked,
    handleGiftListEditRecipientClicked,
    handleDesktopRemoveAddressClicked,
    productsInCart, productAddedToCart, actionRequest, isFetchingModal, refechGiftListOnPageLoad, orderCount,
}) => {
    const [minicartModalOpen, setMinicartModalOpen] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (productAddedToCart && actionRequest === 'HANDLE_GIFT_LIST_ADD_TO_CART_REQUEST') {
            setMinicartModalOpen(true);
        }
    }, [productsInCart]);

    // getting previous state
    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };
    const prevCount = usePrevious(orderCount);

    useEffect(() => {
        // use of this function here to update gift list
        // without page reload if item get deleted
        if (prevCount > orderCount) {
            refechGiftListOnPageLoad();
        }
    }, [orderCount]);

    useEffect(() => {
        dispatch(trackEvent({
            eventCategory: 'Test Impression',
            eventAction: 'Gift List V2',
            eventLabel: '',
            nonInteraction: '1',
        }));
    }, []);

    const   handleMiniCartModalClick = (setModal) => {
        if (minicartModalOpen !== setModal) {
            setMinicartModalOpen(setModal);
        }
    };

    const getMiniCart = () => (minicartModalOpen
        ? (
            <MiniCart
                handleMiniCartModalClick={handleMiniCartModalClick}
                minicartModalOpen={minicartModalOpen}
                setMinicartModalOpen={setMinicartModalOpen}
            />
        ) : <></>
    );
    const rightSideLayout = () => (
        <>
            <div className={classes.title}>
                <span className={classes.titleText}>Gift List</span>
            </div>
            <div className={classes.giftListWrapper}>
                <div className={classes.giftListContainer}>
                    <OccasionDropdown
                        holidays={occasions}
                        selected={occasionId}
                        onChange={(event) => handleNavigateToPage(['/account/gift-list/', event.target.value].join(''), event.target.value, orderId)}
                    />
                </div>

                <Button
                    variant="contained"
                    className={classes.recipientButton}
                    onClick={() => handleGiftListAddNewRecipientClicked(occasionId, 'desktop')}
                >
                    Add Recipient
                </Button>
            </div>
            {recipientsByPage?.map((recipient, index) => (
                <RecipientBoxCollapse
                    recipient={recipient}
                    index={index}
                    onEdit={handleGiftListEditRecipientClicked}
                    onRemove={handleDesktopRemoveAddressClicked}
                />
            ))}
            <DesktopPagination occasionId={occasionId} classes={classes} />
        </>
    );
    return (

        <div className={classes.container}>
            { getMiniCart()}
            <Grid container className={classes.giftListV2Container}>
                <Media query="(max-width: 1023.5px)">
                    {(matches) => (
                        matches ? (
                            <>
                                <h1 className={classes.account}>
                                    <AccountHome giftListV2 disablePageView />
                                    Account Menu
                                </h1>
                                {!isFetchingModal &&  <GraphqlPortalLoader /> }
                                <Grid item xs={12} className={classes.rightContainer}>
                                    {rightSideLayout()}
                                </Grid>
                            </>
                        ) : (
                            <>
                                <AccountLeftMenu
                                    featureFlags={featureFlags}
                                />
                                {!isFetchingModal &&  <GraphqlPortalLoader /> }
                                <Grid item xs={10} className={classes.rightContainer}>
                                    {rightSideLayout()}
                                </Grid>
                            </>
                        )
                    )}
                </Media>
            </Grid>
        </div>
    );
};

GiftListUserV2.propTypes = {
    classes: object.isRequired,
    featureFlags: object.isRequired,
    occasionId: string,
    recipientsByPage: arrayOf(
        shape({
            AddressBookEntryId: string,
            addToCart: string,
            address: shape({
                addressId: string,
                apt: string,
                city: string,
                company: string,
                country: shape({
                    id: string,
                    name: string,
                }),
                street: string,
                zipcode: string,
            }),
            addressId: string,
            firstname: string,
            lastname: string,
            orderItemId: string,
            products: arrayOf(
                shape({
                    id: string,
                    image: string,
                    name: string,
                    partNumber: string,
                    price: number,
                    sku: string,
                }),
            ),
            type: string,
        }),
    ).isRequired,
    handleGiftListAddNewRecipientClicked: func.isRequired,
    handleNavigateToPage: func.isRequired,
    occasions: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    orderId: string.isRequired,
    handleGiftListEditRecipientClicked: func.isRequired,
    handleDesktopRemoveAddressClicked: func.isRequired,
    productAddedToCart: string,
    productsInCart: object,
    isFetchingModal: bool.isRequired,
    actionRequest: string.isRequired,
    refechGiftListOnPageLoad: func.isRequired,
    orderCount: number,
};
GiftListUserV2.defaultProps = {
    productAddedToCart: '',
    productsInCart: {},
    occasionId: '',
    occasions: [],
    orderCount: 0,
};
const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    const orderCount = state?.cart?.orderSize || 0;
    return {
        orderCount,
        orderId: newState.giftList?.orderId,
        occasionId: newState.giftList?.occasionId,
        occasions: newState.giftList?.occasions,
        recipientsByPage: newState.giftList?.recipientsByPage,
        isFetchingModal: newState?.isReadyState,
        productsInCart: newState.giftList?.productsInCart || {},
        productAddedToCart: newState.giftList?.productAddedToCart,
        actionRequest: newState?.actionType,
    };
};
export const mapDispatchToProps = (dispatch) => ({
    handleGiftListAddNewRecipientClicked: (occasionId, template) => dispatch(EventDispatcher.handleGiftListAddNewRecipientClicked(occasionId, template)),
    handleGiftListEditRecipientClicked: (recipient, template, isGiftlistV2) => dispatch(EventDispatcher.handleGiftListEditRecipientClicked(recipient, template, isGiftlistV2)),
    handleDesktopRemoveAddressClicked: (recipient, AddressId, addressType) => dispatch(EventDispatcher.handleDesktopRemoveAddressClicked(
        recipient,
        AddressId,
        addressType,
    )),
    handleNavigateToPage: (url, id, orderId) => dispatch(EventDispatcher.handleNavigateToPage(url, id, orderId)),
});

const enhance = compose(
    trackPage(),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withStyles(styles),
);

export default enhance(GiftListUserV2);
